import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { FormattedMessage } from 'react-intl'
import { getCurrency } from 'core/utils/cultures/unit'

import { Row, Col, Card, Checkbox, Slider, Input } from 'core/components/ui'
import { font, greys } from 'assets/themes/theme-default'
import { stockShape, fundingShape } from '../../shapes'

const Description = styled.p`
  font-weight: ${font.weight.base};
  font-size: ${font.size.base};
  color: ${props => props.theme.colors.color6.bg};
  min-height: 100px;
`

const Price = styled.h2`
  font-weight: ${font.weight.base};
  font-size: ${font.size.sm};
  text-align: center;
  color: ${greys.light4};
  span > span {
    font-weight: ${font.weight.black};
    font-size: ${font.size.lgsm};
  }
`
const DataWrapper = styled.div`
  margin: 15px auto;
  text-align: center;
  text-transform: uppercase;
`
const Label = styled.p`
  font-weight: ${font.weight.base};
  font-size: ${font.size.base};
  color: ${props => props.theme.colors.color6.bg};
  margin: 0;
`

const DataSliderWrapper = styled.div`
  margin: 35px auto 15px;
`

class FundingCard extends React.Component {
  handleOnChangeSelection = () => {
    const { stock, setStock, item } = this.props
    const { funding } = stock

    setStock({
      ...stock,
      funding: funding && funding.label === item.label ? null : item
    })
  }

  calculatePrice = (max, min) => Math.floor(Math.random() * (max - min) + min)

  handleSliderChange = value => {
    const { setStock, stock, item } = this.props
    const { filtersList, funding } = stock
    const { fundingList } = filtersList

    const currentFunding = fundingList.filter(el => el.label === item.label)

    const extendedFunding = {
      ...currentFunding[0],
      monthly: value,
      price: this.calculatePrice(value * 10, value * 25)
    }

    const extendedFundingList = [...fundingList]

    const foundIndex = extendedFundingList.findIndex(el => el.label === item.label)

    extendedFundingList[foundIndex] = extendedFunding

    const extendedFiltersList = {
      ...filtersList,
      fundingList: extendedFundingList
    }

    if (funding && funding.label === item.label) {
      setStock({
        ...stock,
        funding: extendedFunding,
        filtersList: extendedFiltersList
      })
    } else {
      setStock({
        ...stock,
        filtersList: extendedFiltersList
      })
    }
  }

  handleInputChange = e => {
    const { value } = e.target
    const { setStock, stock, item } = this.props
    const { filtersList, funding } = stock
    const { fundingList } = filtersList

    const currentFunding = fundingList.filter(el => el.label === item.label)
    const extendedFunding = {
      ...currentFunding[0],
      bring: Number(value),
      price: this.calculatePrice(300, 600)
    }

    const extendedFundingList = [...fundingList]

    const foundIndex = extendedFundingList.findIndex(el => el.label === item.label)

    extendedFundingList[foundIndex] = extendedFunding

    const extendedFiltersList = {
      ...filtersList,
      fundingList: extendedFundingList
    }

    if (funding && funding.label === item.label) {
      setStock({
        ...stock,
        funding: extendedFunding,
        filtersList: extendedFiltersList
      })
    } else {
      setStock({
        ...stock,
        filtersList: extendedFiltersList
      })
    }
  }

  render = () => {
    const { stock, item } = this.props
    const { funding, selectedVehicle } = stock

    const fundingToDisplay = item
    /*if (funding && item.label === funding.label) {
      fundingToDisplay = funding
    }*/

    return (
      <Card
        bordered={false}
        title={item.label}
        extra={
          <Checkbox
            checked={!funding ? false : item.label === funding.label}
            onChange={() => this.handleOnChangeSelection()}
          />
        }
        actions={[
          <Price>
            <FormattedMessage
              id="stock-funding-card-price"
              values={{
                price: fundingToDisplay.price,
                monthly: fundingToDisplay.monthly,
                currency: getCurrency()
              }}
            />
          </Price>
        ]}
      >
        <Description>{fundingToDisplay.description}</Description>
        <DataWrapper>
          <Label>
            <FormattedMessage id="stock-funding-card-label-1" />
          </Label>
          <Input defaultValue={fundingToDisplay.bring} onBlur={e => this.handleInputChange(e)} />
        </DataWrapper>
        <DataWrapper>
          <Label>
            <FormattedMessage id="stock-funding-card-label-2" />
          </Label>
          <Input value={selectedVehicle.price} disabled />
        </DataWrapper>
        <DataSliderWrapper>
          <Slider
            defaultValue={fundingToDisplay.monthly}
            step={fundingToDisplay.step}
            max={fundingToDisplay.maxStep}
            min={fundingToDisplay.minStep}
            dots
            onChange={value => this.handleSliderChange(value)}
          />
          <Row type="flex">
            <Col span={8}>
              <FormattedMessage
                id="stock-funding-card-month"
                values={{ months: fundingToDisplay.minStep }}
              />
            </Col>
            <Col span={8} offset={8} style={{ textAlign: 'right' }}>
              <FormattedMessage
                id="stock-funding-card-month"
                values={{ months: fundingToDisplay.maxStep }}
              />
            </Col>
          </Row>
        </DataSliderWrapper>
      </Card>
    )
  }
}

FundingCard.propTypes = {
  setStock: PropTypes.func.isRequired,
  stock: stockShape.isRequired,
  item: fundingShape.isRequired
}

export default FundingCard
